import { render, staticRenderFns } from "./RecordComment.vue?vue&type=template&id=5c185e1f&scoped=true"
import script from "./RecordComment.vue?vue&type=script&lang=js"
export * from "./RecordComment.vue?vue&type=script&lang=js"
import style0 from "./RecordComment.vue?vue&type=style&index=0&id=5c185e1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c185e1f",
  null
  
)

export default component.exports